import type { KpiCardSpec } from './card-spec';

/**
 * The New payment methods scalar, shown on the Engagement page's Usage &
 * adoption section and the Users page's User actions section. One object in
 * two catalogs, so the two pages cannot report different figures.
 */
export const NEW_PAYMENT_METHODS_SCALAR_CARD: KpiCardSpec = {
    title: 'New payment methods',
    source: 'payment-methods-added',
    metric: 'paymentMethodsAdded',
    form: 'number',
    size: 'sm',
    description:
        "Counted per brand from each app's own analytics rather than per province, so the Region filter resolves only Quebec alone, the whole rest of Canada, or all of it. Any other province set renders unavailable with the reason, not a partial number. Circle K's coverage of this event is unproven, so a figure that includes the rest of Canada can under-report.",
};
